export const eventFromRow = (row) => ({
  dateType: row.date_type,
  nextEventTime: row.next_event_time,
  eventStartDate: row.event_start_date,
  eventEndDate: row.event_end_date,
  timeZone: row.time_zone,
});
